import React, { useRef, useState, useEffect } from 'react';
import WarningIcon from 'src/assets/icons/WarningOutlineIcon';

const Input = ({ placeholders, types, values, classes, onChangeCallback = () => {}, action, readonly = 0, onPasteCallback = () => {}, onlyNumber = false, min, onKeyPress = () => {}, validationError, minWidth, maxWidth, padding, inputTypes, ...rest}) => {

  const inputRef = useRef(null);
  const spanRef = useRef(null);

  const [resizableValue, setResizableValue] = useState(values);

  useEffect(() => {
    if (spanRef.current && inputRef.current) {  
      spanRef.current.textContent = resizableValue || ' ';
      const spanCurrentWidth = spanRef.current.offsetWidth;
      console.log(spanCurrentWidth, 'spanCurrentWidth');
      let newWidth = '';
      if(spanCurrentWidth < 58) {
        newWidth = Math.min(Math.max(spanCurrentWidth, minWidth), maxWidth);
      } else if(spanCurrentWidth < 145) {
        newWidth = Math.min(Math.max(spanCurrentWidth - 16, minWidth), maxWidth);
      } else {
        newWidth = Math.min(Math.max(spanCurrentWidth - 40, minWidth), maxWidth);
      }
      inputRef.current.style.width = `${newWidth}px`;
    }
  }, [resizableValue]);

  if(readonly == 1) {
    return (
      <React.Fragment>
        <input
          autoComplete='off'
          onClick={action}
          type={types}
          placeholder={placeholders}
          value={values}
          className={`form-field ${classes}`}
          onChange={onChangeCallback}
          readOnly={1}
          {...rest}
        />
      </React.Fragment>
    );
  }

  if(types == 'number') {

    const handleKeyDown = (event) => {
      // Prevent the default behavior if the pressed key is 'e'
      if (event.key === 'e') {
        event.preventDefault();
      }
    };

    return (
      <React.Fragment>
        <input
         autoComplete='off'
          type={types}
          placeholder={placeholders}
          value={values}
          className={`form-field ${classes}`}
          onChange={onChangeCallback}
          onKeyDown={handleKeyDown}
          min={min}
          {...rest}
        />
      </React.Fragment>
    );
  }

  if(inputTypes == 'resizableInput') {
    return (
      <div className='position-relative'>
      <input
        type={types}
        value={values}
        ref={inputRef}
        onChange={(e) => {setResizableValue(e.target.value); onChangeCallback(e)}}
        className={classes}
        placeholder={placeholders}
        style={{
          minWidth: minWidth,
          maxWidth: maxWidth,
          transition: 'width 0.2s ease',
          padding: padding,
        }}
      />
      <span
        ref={spanRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          visibility: 'hidden',
          whiteSpace: 'pre',
          fontSize: '16px',
          padding: padding,
        }}
      />
    </div>
    );
  }


  return (
    <React.Fragment>
      <div className={`w-100 ${validationError? 'warning-field' : ''}`}>
        <input
         autoComplete='off'
          onClick={action}
          type={types}
          placeholder={placeholders}
          value={values}
          className={`form-field ${classes} `}
          onChange={onChangeCallback}
          onKeyPress={onKeyPress}
          onPaste={onPasteCallback}
          {...rest}
        />
        {validationError && <span className="warning-icon">
          <WarningIcon height="16px" width="16px" />
        </span>}
        {validationError && <div className='pt-2 f-13 f-w-400' style={{color: '#117a8b'}}>This field is required.</div>}
      </div>
    </React.Fragment>
  );
};

export default Input;
